type Props = {
  callLength: number;
};

const CallLength = (props: Props) => {
  const { callLength } = props;

  const hours = Math.floor(callLength / 3600)
    .toString()
    .padStart(2, "0");
  const minutes = Math.floor((callLength % 3600) / 60)
    .toString()
    .padStart(2, "0");
  const seconds = Math.floor(callLength % 60)
    .toString()
    .padStart(2, "0");

  return (
    <>
      {hours}:{minutes}:{seconds}
    </>
  );
};

export default CallLength;
